import {
  Box,
  Breadcrumbs,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Modal,
  Typography,
} from "@mui/material";
import {
  Check as CheckIcon,
  Delete,
  Pause,
  PlayArrow,
  Save,
  Stop,
} from "@mui/icons-material";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { RegistryFieldsType, RegistryWidgetsType } from "@rjsf/utils";
import { addDatapoint, syncOneDatapoint } from "../../indexDB/utils/datapoint";
import { getAccessToken, isUUID, sendDataTusd, zip } from "../../utils";

import AppInstructions from "../introPage/AppInstructions";
import CollapsibleWidget from "../collapsibleWidget/CollapsibleWidget";
import ConsentComponent from "./Consent";
import CustomDropdown from "./CustomDropDown";
import CustomQuesItm from "./CustomQuesItm";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileFactory from "../customComponents/fileWidget/FileFactory";
import FilesUploadModel from "../Archive/filesUploadModel/filesUploadModel";
import Form from "@rjsf/mui";
import InfoIcon from "@mui/icons-material/Info";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { QRCodeSVG } from 'qrcode.react';
import QrScanner from "./QrScanner";
import Stack from '@mui/material/Stack';
import TabWidget from "../tabWidget/tabWidget";
import axios from "axios";
import config from "../../config";
import { createRoot } from 'react-dom/client';
import { db } from "../../indexDB/model";
import { deleteDraftbyId } from "../../indexDB/utils/draft";
import { getLastModifiedDatetime } from "../../utils/methods";
import { useNavigate } from "react-router-dom";
import validator from "@rjsf/validator-ajv8";
import { v4 as uuidv4 } from "uuid";

const Datapoint = (props) => {
  const fileData = useRef(props.fileData ? props.fileData : []);
  const prevFormData = props.prevFormData ? props.prevFormData : {};
  const currentDomain = process.env.REACT_APP_DOMAIN;
  const domainConfig = config[currentDomain];
  const endpoint = domainConfig.apiEndpoint;
  const formRef = useRef({});
  const requiredFieldsRef = useRef([]);

  const draftId = useRef(props.draftId || uuidv4());
  const [draftDatetime, setDraftDatetime] = useState({ timeStampInt: props.draftDatetime, timeStampStr: getLastModifiedDatetime(props.draftDatetime) });
  const [isErr, setErr] = useState("");
  const [savingDraft, setSavingDraft] = useState(false)
  const [isFormRendering, setFormRendering] = useState(true);
  const [formData, setFormData] = useState(prevFormData);
  const [formSaved, setFormSaved] = useState(false);
  const [schema, setSchema] = useState({});
  const [fileAttributes, setFileAttributes] = useState({});
  const [showFile, setShowFile] = useState({});
  const [projectName, setProjectName] = useState("");
  const [datasetName, setDatasetName] = useState("");
  // const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [selectedBreadcrumb, setSelectedBreadcrumb] = useState("");
  const [resetFormdata, setResetFormdata] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [consentInfo, setConsentInfo] = useState(null);
  const [showConsent, setShowConsent] = useState(true);
  const [showLoading, setShowLoading] = useState(false);
  const [dataset, setDataset] = useState("");
  const [requiredFields, setRequiredFields] = useState([]);
  const [showRequiredFieldModal, setShowRequiredFieldModal] = useState(false);
  const [uiSchema, setUISchema] = useState({});
  const [autoSaveStart, setAutoSaveStart] = React.useState(false)
  const [collapseSections, setCollapseSections] = React.useState(props.collapsibleSections || createCollapsibleSections())
  const collapsibleSectionsRef = useRef(props.collapsibleSections || createCollapsibleSections())
  const draftSavedUpdateAtMin = 1
  const { handleLogout, getAllCounts } = props
  // Hotfix: initializing with 0
  const [userDetails, setUserDetails] = useState({
    latitude: 0,
    longitude: 0,
    timestamp: 0,
  });
  const locationLogging = domainConfig?.features?.locationLogging;
  const QRCodeEnabled = domainConfig.features?.QRCodeEnabled;

  const history = useNavigate();
  const handleBreadcrumbClick = (breadcrumb) => {
    setSelectedBreadcrumb(breadcrumb);
    handleConfirmModalConfirm()
  };

  const handleConsent = () => {
    setShowConsent(!showConsent);
    setTimeout(() => { setAutoSaveStart(true) }, 500)
  };

  const handleConfirmModalConfirm = () => {
    history("/home", { state: { selectedProjectProp: projectName, selectedDatasetProp: props?.dataset?.uuid } });
  };

  function generateCollapsibleSectionId(key = undefined) {
    return key ? `root_${key}__title` : 'root__title'
  }

  const findFirstRequiredField = useCallback((schema, idSchema = "") => {
    if (schema.required && schema.required.length > 0) {
      const firstRequiredField = schema.required[0];
      return idSchema + "_" + firstRequiredField;
    }

    if (schema.properties) {
      for (const key in schema.properties) {
        const fieldSchema = schema.properties[key];
        const fieldIdSchema = idSchema ? idSchema + "_" + key : key;
        const result = findFirstRequiredField(fieldSchema, fieldIdSchema);
        if (result !== "") {
          return result;
        }
      }
    }
    return "_init";
  }, []);

  function createCollapsibleSections() {
    const renamedIds = {}
    const collapsibleKey = "collapsible"
    const schemaa = props.dataset?.schema;
    if (schemaa.hasOwnProperty("properties")) {
      if (schemaa.hasOwnProperty(collapsibleKey)) {
        renamedIds[generateCollapsibleSectionId()] = !!schema[collapsibleKey];
      }
      for (const key in schemaa?.properties) {
        if (schemaa?.properties[key].hasOwnProperty("properties")) {
          if (schemaa?.properties[key].hasOwnProperty(collapsibleKey)) {
            renamedIds[generateCollapsibleSectionId(key)] = schemaa?.properties[key][collapsibleKey];
          }
        }
      }
    }
    return renamedIds
  }

  useEffect(() => {
    setProjectName(localStorage.getItem("project"));
    if (props.dataset) {
      setDataset(props.dataset);
      setDatasetName(props.dataset?.name);
      setSchema(props.dataset?.schema);
      setUISchema(props.dataset?.schema?.ui_schema);
    } else {
      fetchDataset();
    }

    if (locationLogging && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setUserDetails({ latitude: position?.coords?.latitude, longitude: position?.coords?.longitude, timestamp: position?.timestamp });
      });
    }
  }, []);

  useEffect(() => {
    if (schema?.properties) {
      const errStatus = findFirstRequiredField(schema, "root");
      if (errStatus !== "_init") {
        setErr(errStatus);
      }
    }
  }, [schema, findFirstRequiredField]);

  useEffect(() => {
    setResetFormdata(schema?.resetForm ? false : true);
    setConsentInfo(schema?.consent);
    setShowConsent(schema?.consent && !props.draftId ? true : false);
  }, [schema]);

  async function fetchDataset() {
    setShowLoading(true);
    try {
      var access_token = getAccessToken();
    } catch (error) {
      console.log(error);
    }

    const project_id = localStorage.getItem("project_id");
    const dataset_id = localStorage.getItem("dataset_id");

    try {
      const response = await axios.get(
        `${endpoint}project/dataset/?project=${project_id}&id=${dataset_id}&upload_type=django`,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      console.log(response);
      setDataset(response.data.datasets[0]);
      setDatasetName(response.data.datasets[0].name);
      setSchema(response.data.datasets[0].schema);
      setTimeout(() => {
        setShowLoading(false);
      }, 500);
    } catch (error) {
      console.error("Error getting the dataset:", error);
    }
  }

  const resetFormData = () => {
    setDataset(props.dataset);
    setDatasetName(props.dataset?.name);
    setSchema(props.dataset?.schema);
    setUISchema(props.dataset?.schema?.ui_schema);
    setShowConsent(false)
    fileData.current = []
    const collapseibleIds = createCollapsibleSections()
    collapsibleSectionsRef.current = collapseibleIds
    setCollapseSections(collapseibleIds)
    customCollapsibleFeature()
  }

  async function handleDirectAPI(formData) {
    setShowLoading(true);

    try {
      // validation to the form, not really
      const response = await addDatapoint(formData, formRef.current, draftId.current, userDetails);
      const { setDatapointId } = props
      if (setDatapointId) {
        setDatapointId(response);
      }
      if (navigator.onLine) {
        try {
          syncOneDatapoint(response, handleLogout, getAllCounts)
          console.log("auto-synced datapoint")
        } catch {
          console.log("failed to auto-sync")
        }
      }

      formRef.current = {};
      setShowFile({});
      setFormData({});
      setFormSubmitted(true);
      setShowButtons(false);
      // Reset things
      resetFormData()
      setTimeout(() => {
        // handleNewForm()
        handleConfirmModalConfirm()
        setShowButtons(true);
        deleteDraftbyId(draftId.current);
      }, 1000);
    } catch (error) {
      console.error("Error submitting datapoint:", error);
    }
    setShowLoading(false);
    const { setSubmit } = props
    if (setSubmit) {
      setSubmit(true);
    }
  }

  // async function handleTusdAPI(formData) {
  //   const metaStruct = {};
  //   Object.keys(fileAttributes).forEach((key) => {
  //     metaStruct[key] = fileAttributes[key].map((item) => item.name);
  //   });

  //   var jsonse = JSON.stringify(formData);
  //   const dataJson = {};
  //   dataJson["data"] = jsonse;
  //   dataJson["dataset"] = dataset.id;
  //   var blob = new Blob([JSON.stringify(dataJson)], {
  //     type: "application/json",
  //   });
  //   var jsonParam1 = new File([blob], "answer.json", {
  //     type: "application/json",
  //   });

  //   let filesBody = [jsonParam1];
  //   Object.keys(fileAttributes).forEach((itm) => {
  //     filesBody = filesBody.concat(fileAttributes[itm]);
  //   });
  //   zip(filesBody)
  //     .then((content) => {
  //       sendDataTusd(content, metaStruct);
  //       setFileAttributes({});
  //       deleteDraftbyId(draftId.current);
  //       setShowFile({});
  //     })
  //     .catch((error) => {
  //       console.error("Error generating zip file:", error);
  //     });
  // }

  function areAllRequiredFieldsFilled(requiredFields, fileAttributes) {
    for (const field of requiredFields) {
      if (!fileAttributes[field] || fileAttributes[field].length === 0) {
        return !focusElementWithRedBorder(`${field}`);
      }
    }
    return true;
  }

  function handleNewForm() {
    setFormSubmitted(false);
    setShowConsent(true);
    draftId.current = uuidv4()
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (draftDatetime.timeStampInt) {
        setDraftDatetime(prev => ({ ...prev, timeStampStr: getLastModifiedDatetime(prev.timeStampInt) }))
      }
    }, draftSavedUpdateAtMin * 60000)
    const timeoutId = setTimeout(() => {
      setAutoSaveStart(true)
    }, 100)
    return () => {
      clearInterval(interval)
      clearTimeout(timeoutId)
      // handleSaveDraft(formData, dataset)
    }
  }, [])
  const handleSaveDraft = async (formDataParam = null, datasetParam = null, userDetailsParam = null) => {
    setSavingDraft(true)
    const drftId = draftId.current;
    const item = await db.drafts.where("draftId").equals(drftId).first();
    const formId = datasetParam ? datasetParam.uuid : dataset.uuid;
    const currentTime = new Date();
    const timestamp = currentTime.getTime();
    const updatedData = {
      fileData: formRef.current,
      timestamp: timestamp,
      collapsibleSections: collapsibleSectionsRef.current,
      latitude: userDetailsParam?.latitude || userDetails?.latitude,
      longitude: userDetailsParam?.longitude || userDetails?.longitude,
      timestamp: timestamp
    }
    if (formDataParam) {
      updatedData["formData"] = formDataParam
    }
    setDraftDatetime(prev => ({ timeStampInt: timestamp, timeStampStr: getLastModifiedDatetime(timestamp) }))
    if (item) {
      await db.drafts.where("draftId").equals(drftId).modify(updatedData);
    }
    else {
      await db.drafts.add({
        draftId: drftId,
        datasetId: formId,
        ...updatedData
      })
    }
    setTimeout(() => { setSavingDraft(false) }, 500)
  }

  const handleSubmit = async ({ formData, errors }, e) => {
    setFormData(formData);
    if (
      !areAllRequiredFieldsFilled(requiredFieldsRef.current, formRef.current)
    ) {
      return;
    }

    switch (dataset.upload_type) {
      case "django":
        handleDirectAPI(formData);
        break;
      // case "tus":
      //   handleTusdAPI(formData);
      //   break;
      default:
        handleDirectAPI(formData);
        console.log("Dataset Upload Type Missing.");
    }
  };

  const customWidgets = {
    FileWidget: (props) => (
      <FileFactory
        requiredFieldsRef={requiredFieldsRef}
        formRef={formRef}
        filesData={fileData.current}
        handleSaveDraft={handleSaveDraft}
        {...props}
      />
    ),
    QrScannerWidget: (props) => (
      <QrScanner
        questionTitle={props.schema.title}
        optionalValue={props.value}
        onChange={props.onChange}
        disabled={false}
      />
    )
  };

  function transformErrors(errors, uiSchema) {
    return errors.map((error) => {
      if (error.name === "required") {
        error.message = `${error.params.missingProperty} is mandatory`;
      }
      return error;
    });
  }

  function focusElementWithRedBorder(id) {
    const element = document.getElementById(id);
    if (element) {
      const elemIds = element.id.split('.')
      elemIds.forEach((item) => {
        const generatedId = generateCollapsibleSectionId(item);
        if (collapseSections.hasOwnProperty(generatedId)) {
          collapseSections[generatedId] = false;
          updateUiOnCollpaseClick(generatedId);
        }
      })
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      element.style.border = "2px solid red";
      element.style.borderRadius = "10px";
      element.style.padding = "10px";
      return true;
    }
    return false;
  }

  const debounceFunc = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  }

  const onChangeSaveDraftDebound = useCallback(
    debounceFunc((formData, dataset, userDetails) => {
      handleSaveDraft(formData, dataset, userDetails);
    }, 1000),
    []
  );

  const onFormChange = ({ formData }) => {
    setFormData(formData)
    if (autoSaveStart) {
      onChangeSaveDraftDebound(formData, dataset, userDetails)
    }
  }

  const customCollapsibleFeature = () => {
    const handleClick = (e) => {
      const clickedId = e.currentTarget.id
      setCollapseSections((prev) => ({
        ...prev,
        [clickedId]: !prev[clickedId]
      }));
      e.currentTarget.nextElementSibling.style.display = collapseSections[clickedId] ? 'block' : 'none'
    };

    // Add event listeners for all elements in collapseSections
    Object.keys(collapseSections).forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        element.addEventListener('click', handleClick);
        if (element.nextElementSibling) {
          element.nextElementSibling.style.display = collapseSections[id] ? 'none' : 'block';
        }
        element.style.cursor = 'pointer'
        const iconContainer = document.createElement('div');
        iconContainer.style.position = 'absolute';
        iconContainer.style.right = '0'
        iconContainer.style.top = '2px'
        if (element.firstChild) {
          element.firstChild.style.marginRight = "50px"
          element.firstChild.style.marginBottom = "5px"
        }
        const iconButton = (
          <IconButton >
            <ExpandMoreIcon id={`${id}_icon_more`} style={{ display: collapseSections[id] ? 'block' : 'none', fontSize: "2rem" }} />
            <ExpandLessIcon id={`${id}_icon_less`} style={{ display: collapseSections[id] ? 'none' : 'block', fontSize: "2rem" }} />
          </IconButton>
        );
        const root = createRoot(iconContainer);
        root.render(iconButton);
        const hrElement = element.querySelector('hr');
        if (hrElement) {
          element.insertBefore(iconContainer, hrElement);
          hrElement.style.borderWidth = "1.5px";
          hrElement.style.borderColor = "#999";
        }
      }
    });
    return () => {
      Object.keys(collapseSections).forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.removeEventListener('click', handleClick);
        }
      });
    };
  }

  useEffect(() => {
    if (props.draftId ? autoSaveStart : (autoSaveStart && !showConsent)) {
      customCollapsibleFeature()
    }
  }, [showConsent, autoSaveStart]);

  const updateUiOnCollpaseClick = (id) => {
    const element = document.getElementById(id);
    if (element && collapseSections.hasOwnProperty(id)) {
      collapsibleSectionsRef.current = collapseSections
      if (element.nextElementSibling) {
        element.nextElementSibling.style.display = collapseSections[id] ? 'none' : 'block'
      }
      const moreIconButtonElem = document.getElementById(`${id}_icon_more`)
      if (moreIconButtonElem) {
        moreIconButtonElem.style.display = collapseSections[id] ? 'block' : 'none'
      }
      const lessIconButtonElem = document.getElementById(`${id}_icon_less`)
      if (lessIconButtonElem) {
        lessIconButtonElem.style.display = collapseSections[id] ? 'none' : 'block'
      }
    }
  }

  useEffect(() => {
    if (collapseSections) {
      Object.keys(collapseSections).forEach((id) => {
        updateUiOnCollpaseClick(id)
      });
    }
  }, [collapseSections])


  return (
    <Container sx={{ paddingTop: { xs: "12px", sm: "16px" } }}>
      {formSubmitted ? ( // If form is submitted, show the confirmation message
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: { xs: "100px", sm: "300px" },
          }}
        >
          <div
            style={{
              margin: "16px",
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              backgroundColor: "green",
              border: "4px solid gray",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckIcon style={{ color: "white", fontSize: "28px" }} />
          </div>
          <Typography variant="body1">Form saved</Typography>
          <Typography variant="body2">Thanks for sharing your info</Typography>
          {showButtons && ( // Show buttons after 3 seconds
            <Box sx={{ paddingTop: "10px" }}>
              <Button onClick={handleNewForm}>New Form</Button>
              <Button onClick={() => history("/")}>Home Page</Button>
            </Box>
          )}
        </Box>
      ) : (
        <Box>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Breadcrumbs aria-label="breadcrumb">
              <Typography sx={{ fontSize: { xs: "12px", sm: "16px" } }}>
                Project
              </Typography>
              <Link
                underline="always"
                sx={{ cursor: "pointer", fontSize: { xs: "12px", sm: "16px" } }}
                onClick={() => handleBreadcrumbClick("Project")}
              >
                {projectName}
              </Link>
              <Link
                underline="always"
                sx={{ cursor: "pointer", fontSize: { xs: "12px", md: "16px" } }}
              // onClick={() => handleBreadcrumbClick("Dataset")}
              >
                {datasetName}
              </Link>
            </Breadcrumbs>
            <Box sx={{ position: "relative" }}>
              {QRCodeEnabled &&
                <Box
                  sx={{
                    border: '2px solid black',
                    borderRadius: '8px',
                    padding: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}
                >
                  <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>ID</Typography>
                  <QRCodeSVG value={draftId.current} size={100} />
                </Box>}
              {(!showConsent || props.draft) && <>
                <Button onClick={() => handleSaveDraft()}>{savingDraft ? <Box display="flex" alignItems="center"><CircularProgress size={24} /><Box ml={1}>Saving</Box></Box>
                  : 'Save Draft'}</Button>
                <Typography sx={{ fontSize: { sm: "12px", color: "#ccc" }, position: "absolute", right: 0, textWrap: "nowrap" }}>
                  {draftDatetime.timeStampStr}
                </Typography>
              </>}
            </Box>
          </Stack>

          {(showConsent) ? (
            <div>
              <ConsentComponent
                handleConsent={handleConsent}
                consentInfo={consentInfo}
              />
            </div>
          ) : (
            <div>
              {/* <Modal open={confirmModalOpen} onClose={handleConfirmModalClose}>
                <Dialog
                  onClose={handleConfirmModalClose}
                  open={confirmModalOpen}
                >
                  <DialogTitle>Confirm Your Action</DialogTitle>
                  <DialogContent>
                    <Typography variant="body1">
                      Your progress on the form will be lost. Are you sure you
                      want to proceed?
                    </Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleConfirmModalClose}>Cancel</Button>
                    <Button onClick={handleConfirmModalConfirm}>Confirm</Button>
                  </DialogActions>
                </Dialog>
              </Modal> */}

              <Dialog open={showLoading} maxWidth="xs">
                <DialogContent sx={{ textAlign: "center", padding: "20px" }}>
                  <CircularProgress sx={{ marginBottom: "10px" }} />
                  <Typography variant="body1">Fetching the form!</Typography>
                </DialogContent>
              </Dialog>

              <Dialog open={showRequiredFieldModal} maxWidth="xs">
                <DialogContent sx={{ textAlign: "center", padding: "20px" }}>
                  <Typography variant="body1">
                    You haven't filled all the required fields.
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setShowRequiredFieldModal(false)}>
                    Okay
                  </Button>
                </DialogActions>
              </Dialog>

              {schema ? (
                <Box sx={{ paddingTop: "10px" }}>
                  <Form
                    schema={schema}
                    onSubmit={handleSubmit}
                    formData={formData}
                    onChange={onFormChange}
                    uiSchema={uiSchema}
                    validator={validator}
                    liveValidate
                    widgets={customWidgets}
                    showErrorList=""
                    transformErrors={transformErrors}
                  />
                </Box>
              ) : (
                <AppInstructions />
              )}
            </div>
          )}
        </Box>
      )}
    </Container>
  );
};

export default Datapoint;
